import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import clsx from "clsx";
import { GitBranch } from "react-feather";

type HoverCardProps = {
  branch?: string;
};

export const BranchingHoverCard: React.FC<HoverCardProps> = ({ branch }) => {
  return (
    <HoverCardPrimitive.Root>
      <HoverCardPrimitive.Trigger asChild>
        <GitBranch className="font-bold" size={14} />
      </HoverCardPrimitive.Trigger>

      <HoverCardPrimitive.Portal className="transition">
        <HoverCardPrimitive.Content
          align="center"
          sideOffset={4}
          className={clsx(
            "radix-side-top:animate-slide-up radix-side-bottom:animate-slide-down shadow-md transition",
            "rounded-xl p-4",
            "bg-white",
            "animate-intro-fade focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75",
          )}>
          <HoverCardPrimitive.Arrow className="fill-current text-white" />

          <div className="flex h-full w-full space-x-4">
            <div
              className={clsx(
                "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gray-50/60 p-2.5 shadow-inner",
              )}>
              <GitBranch className="h-10 w-10" />
            </div>

            <div>
              <h3 className="text-sm font-medium text-gray-900">Branching step</h3>

              <p className="mt-1 text-sm font-normal text-gray-700">
                If a user selects this option, they&apos;ll be taken to the configured step.
              </p>
            </div>
          </div>
        </HoverCardPrimitive.Content>
      </HoverCardPrimitive.Portal>
    </HoverCardPrimitive.Root>
  );
};
